module.exports = __webpack_public_path__ + "static/media/Pet-Catalog.4e12bb09.pdf";